export default __webpack_public_path__ + "static/media/banknote.5834dd1a.png";